// Thank-you screen: shown after a guest completes a flow. Julie's voice per
// julie-voice.md: short, warm, no corporate language, "thank-you" hyphenated.
// Each flow gets its own copy via the `flow` prop.

var COPY = {
  lead: {
    title: function (name) { return 'Thank-you, ' + name + '!'; },
    body: 'Your request is in. Julie will look it over and reach out with a quote soon.',
    detail: 'She usually replies within a day. If you need to reach her sooner, call or text 507-693-7825.',
    showReset: true
  },
  reservation: {
    title: function (name) { return 'Thank-you, ' + name + '!'; },
    body: 'Your reservation is locked in. Julie will send over the rental agreement for you to sign, and your first payment details will follow.',
    detail: 'Check your email for the agreement from GoodSign. If you need anything, call or text 507-693-7825.',
    showReset: false
  },
  arrival: {
    title: function (name) { return 'Got it, ' + name + '!'; },
    body: 'Your arrival details are in. We can\'t wait to welcome you to the villa.',
    detail: 'Julie will send the gate code and check-in info on the day you arrive. Anything urgent before then? Just text 507-693-7825.',
    showReset: false
  },
  vrbo_intake: {
    title: function (name) { return 'Got it, ' + name + '!'; },
    body: 'So glad everything\'s in. We\'re all set for your stay at One Beach Road.',
    detail: 'Julie will send the gate code and check-in info on the day you arrive. Anything before then? Just call or text 507-693-7825.',
    showReset: false
  },
  // Square checkout return (WP-F): Square appends ?transactionId=..&orderId=..
  // to the payment link's redirect_url after a successful payment. No guest
  // name is available on this URL, and the copy must hold for BOTH legs —
  // leg 1 (booking confirmation follows once the webhook + agreement gate
  // close) and leg 2 (already confirmed, receipt only).
  payment: {
    title: function () { return 'Payment received — thank-you!'; },
    body: 'Your payment went through. If this was your first installment, your booking confirmation lands in your inbox within a few minutes.',
    detail: 'Square emails your receipt. Anything at all, call or text 507-693-7825.',
    showReset: false
  }
};

export function ThankYou({ name, flow, onReset }) {
  var c = COPY[flow] || COPY.lead;
  return (
    <div class="surface thankyou">
      <h2>{c.title(name || '')}</h2>
      <p>{c.body}</p>
      <p>{c.detail}</p>
      {c.showReset
        ? <button type="button" onClick={onReset}>Start a new request</button>
        : null}
    </div>
  );
}
